var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('doclink',{attrs:{"n":_vm.n,"t":_vm.t,"p":"faq"}})
}
var staticRenderFns = []

export { render, staticRenderFns }